import { Component, ElementRef, OnInit} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import {Location} from '@angular/common';
import { ErrorType } from 'src/app/enums/error-type.enum';

@Component({
  selector: 'fury-add-edit-sub-covered-item',
  templateUrl: './add-edit-sub-covered-item.component.html',
  styleUrls: ['./add-edit-sub-covered-item.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AddEditSubCoveredItemComponent implements OnInit {

  subCoverItemForm!:FormGroup;
  hide:boolean = true;
  coverItemId!:string;
  subCoverItemId !: string;
  details:any;

  constructor(
    private apiService: ApiService,
    public location: Location,
    private activateRoute: ActivatedRoute
  ) { 
    this.activateRoute.params.subscribe((res:any)=>{
      this.coverItemId = res.coverItemId;
      if(res.subCoverItemId){
        this.subCoverItemId = res?.subCoverItemId;
        this.getSubCoverItemDetails();
      }
    })
  }

  ngOnInit(): void {
    this.formInit();
  }
  formInit(){
    this.subCoverItemForm = new FormGroup({
      title: new FormControl('', [Validators.required]),
      averageCostForRepair: new FormControl('', [Validators.min(0)]),
      averageCostForReplacement: new FormControl('', [Validators.min(0)]),
      description: new FormControl(''),
      commonIssues: new FormControl(''),
    })
  };
  getSubCoverItemDetails(){
    this.apiService.get(`admin/plan/sub-covered-item/get-sub-covered-item/${this.subCoverItemId}`).subscribe((res: any)=>{
      if(res.body){
        this.details = res?.body?.planCoverItem;
        this.subCoverItemForm.patchValue(res?.body?.planCoverItem);
      }
    })
  };
  addEdit(){
    if(this.subCoverItemForm.valid){
      const data = this.subCoverItemForm.value;
      data.coveredItemId = this.coverItemId;
      if(!this.subCoverItemId){
        this.apiService.post(`admin/plan/sub-covered-item/create-sub-covered-item`, data).subscribe((res: HttpResponse<any>)=>{
          if(res.body){
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.location.back();
          }
        }, (err: HttpErrorResponse)=>{
          this.apiService.alert(err.message, ErrorType.Error);
        })
      } else {
        this.apiService.post(`admin/plan/sub-covered-item/update-sub-covered-item/${this.subCoverItemId}`, data).subscribe((res: HttpResponse<any>)=>{
          if(res.body){
            this.apiService.alert(res.body.message, ErrorType.Success);
            this.location.back();
          }
        }, (err: HttpErrorResponse)=>{
          this.apiService.alert(err.message, ErrorType.Error);
        })
      }
    } else {
      this.subCoverItemForm.markAllAsTouched();
    }
  };



}
